import escape from 'lodash.escape';

const specialCharsTransformationMap = {
  '\n': ' ',
};

const avoidedCharactersRegExp = /[^a-zA-Z0-9.,_\\\-\s]/g;

/**
 * Function to handle WAF's reject
 * It should be called as a String.map() parameter
 * If we have "&&" in the request's body, WAF would think is a SQL Injection
 * @param {string} char
 * @param {number} index
 * @param {string[]} strArray
 * @returns {string[]}
 */
const avoidDoubleAmpersand = (char, index, strArray) =>
  char === '&' && strArray[index + 1] === '&' ? `${char} ` : char;

export const isObject = item =>
  typeof item === 'object' && !Array.isArray(item) && item !== null;

const generateRegExpFromObjectKeys = object => {
  const characterToString = Object.keys(object).join('');
  return new RegExp(`[${characterToString}]`, 'g');
};

const isSpecialChar = char => char.charAt(0) === '\\';

const addressSpecialCharacters = map => {
  const newMap = {};
  Object.keys(map).forEach(char => {
    if (isSpecialChar(char)) {
      newMap[char.slice(1, char.length)] = map[char];
    } else {
      newMap[char] = map[char];
    }
  });
  return newMap;
};

/** @param {string} str */
export const escapeHTML = str => (str ? escape(str) : '');

/** @param {string} str @returns {string} */
export const escapeSpecialChars = str =>
  str ? escapeToHTML(str).split('').map(avoidDoubleAmpersand).join('') : str;

const removeExtraSpaces = string =>
  string
    .replace(/\s+/g, ' ')
    .replace(/^\s|\s$/g, '')
    .trim();

const escapeToHTML = str =>
  str.replace(avoidedCharactersRegExp, char => `&#${char.charCodeAt(0)}#&`);

const escapeCharactersToCodeInString = (string, customStringParser) => {
  if (customStringParser) {
    return customStringParser(string);
  }

  const mapReplacerWithoutSpecialChars = addressSpecialCharacters(
    specialCharsTransformationMap,
  );
  const replacer = match =>
    match in mapReplacerWithoutSpecialChars
      ? mapReplacerWithoutSpecialChars[match]
      : match;
  const mappedRegExp = generateRegExpFromObjectKeys(
    specialCharsTransformationMap,
  );

  const textEscaped = removeExtraSpaces(
    escapeToHTML(string.replace(mappedRegExp, replacer)),
  );

  return textEscaped;
};

const escapeCharactersInObjectStrings = (
  obj,
  whitelist = [],
  customStringParser,
) => {
  const newObj = { ...obj };

  Object.keys(newObj).forEach(key => {
    if (!whitelist.includes(key)) {
      if (typeof newObj[key] === 'string') {
        const escapedString = escapeCharactersToCodeInString(
          newObj[key],
          customStringParser,
        );
        newObj[key] = escapedString;
      } else if (isObject(obj[key])) {
        newObj[key] = escapeCharactersInObjectStrings(
          obj[key],
          whitelist,
          customStringParser,
        );
      } else if (Array.isArray(newObj[key])) {
        const arr = newObj[key].map(item => {
          let arrayItem;
          if (typeof item === 'string') {
            const escapedString = escapeCharactersToCodeInString(
              item,
              customStringParser,
            );
            arrayItem = escapedString;
          } else if (isObject(item)) {
            arrayItem = escapeCharactersInObjectStrings(
              item,
              whitelist,
              customStringParser,
            );
          }
          return arrayItem;
        });

        newObj[key] = arr;
      }
    }
  });

  return newObj;
};

export default escapeCharactersInObjectStrings;
